export const INVALID_FORMAT_MESSAGE =
  "El teléfono debe tener 10 dígitos (sin 0, 15, 54 ni +549).";

export function extractDigits(phone) {
  return String(phone ?? "").replace(/\D/g, "");
}

export function isValidArgentinePhone(phone) {
  const digits = extractDigits(phone);
  if (digits.length !== 10) {
    return false;
  }
  if (
    digits.startsWith("0") ||
    digits.startsWith("15") ||
    digits.startsWith("54")
  ) {
    return false;
  }
  return true;
}

export function normalizePhoneInput(phone) {
  return extractDigits(phone);
}
